import React from "react"
import * as R from "ramda"
import { withRouter } from "react-router"
import ReactPixel from "react-facebook-pixel"
import TwitterConvTrkr from "react-twitter-conversion-tracker-plus"
import { getParticipants, firePixel } from "../../api/async/participants/index"
import { postOmise, postPaypal } from "../../api/async/payment/index"
import { Loader } from "../../components/Loader"
import { SummaryParticipant } from "../../organisms/SummaryParticipant/index"
import { endRegisterRace } from "../../utils"

class Payment extends React.Component {
  state = {
    participant: {},
    bankAccountModalOpen: false
  }

  toggleBankAccountModal = () => {
    this.setState({ bankAccountModalOpen: !this.state.bankAccountModalOpen })
  }

  componentDidMount() {
    getParticipants({ id: this.props.match.params.id }).then(res => {
      const participant = res.data[0]
      this.setState({ participant })
      if (
        (R.path(["race_detail", "race", "close_registration"], participant) ||
          endRegisterRace(R.path[("race_detail", "race")], participant)) &&
        !participant.is_paid
      ) {
        this.props.history.push("/me")
      }
    })
  }

  onPaypalSuccess = payment => {
    if (payment.paid) {
      postPaypal({
        participant: this.state.participant.id,
        payment_id: payment.paymentID
      }).then(res => res.status === 200 && this.props.history.push(`/me}`))
    }
  }
  onOmiseSuccess = (token, amount) => {
    postOmise({
      participant: this.state.participant.id,
      token,
      amount
    }).then(res => {
      if (res.status === 200) {
        firePixel(this.state.participant)
        TwitterConvTrkr.track("Purchase")
        ReactPixel.track("Purchase", {
          value: amount / 100,
          currency: "THB"
        })
        this.props.history.push(
          `/participants/${this.state.participant.id}/payment/thank-you`
        )
      }
    })
  }

  render() {
    return this.state.participant !== {} ? (
      <SummaryParticipant
        participant={this.state.participant}
        bankAccountModalOpen={this.state.bankAccountModalOpen}
        toggleBankAccountModal={this.toggleBankAccountModal}
        onPaypalSuccess={this.onPaypalSuccess}
        onOmiseSuccess={this.onOmiseSuccess}
      />
    ) : (
      <Loader />
    )
  }
}

export default withRouter(Payment)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Payment/index.js